angular.module("UI8.components").component("favorites", {
  template: `<div class="page favorites" ng-if="$ctrl.grandTotal">
      <div class="page__container container">
        <div class="page__hero">
          <h1 class="page__title">Your favorites</h1>
          <div class="page__description">
            {{ $ctrl.grandTotal }} saved product{{ $ctrl.grandTotal === 1 ? '' : 's' }}<span ng-if="$ctrl.onSaleCount"> &mdash; {{ $ctrl.onSaleCount }} on sale right now</span>
          </div>
        </div>
        <div class="page__filters filters filters--favorites">
          <div class="filters__container">
            <div class="filters__tags filters__tags--favorites" ng-if="$ctrl.categories.length > 1">
              <div class="filters__scroll">
                <div class="filters__inner">
                  <button class="filters__btn" ng-class="{active: !$ctrl.category}" ng-click="$ctrl.setCategory(null)">All</button>
                  <button class="filters__btn" ng-repeat="cat in ::$ctrl.categories track by cat.slug" ng-class="{active: $ctrl.category === cat.slug}" ng-click="$ctrl.setCategory(cat.slug)">{{ cat.name }} ({{ cat.count }})</button>
                </div>
              </div>
              <button class="filters__nav filters__nav--prev" type="button" aria-label="Scroll categories back"></button>
              <button class="filters__nav filters__nav--next" type="button" aria-label="Scroll categories forward"></button>
            </div>
            <div class="filters__select">
              <div class="filters__head">
                <div class="filters__arrow">
                  <svg><path d="M7.414 10c-.891 0-1.337-1.077-.707-1.707l4.586-4.586a1 1 0 0 1 1.414 0l4.586 4.586c.63.63.184 1.707-.707 1.707H7.414zm8.882 5c.928 0 1.356 1.155.651 1.759l-4.297 3.683a1 1 0 0 1-1.302 0l-4.297-3.683C6.347 16.155 6.775 15 7.703 15h8.593z"/></svg>
                </div>
              </div>
              <div class="filters__dropdown">
                <button class="filters__btn" ng-class="{active: $ctrl.sort === 'recent'}" ng-click="$ctrl.setSort('recent')">Recently added</button>
                <button class="filters__btn" ng-class="{active: $ctrl.sort === 'low'}" ng-click="$ctrl.setSort('low')">Lowest price</button>
                <button class="filters__btn" ng-class="{active: $ctrl.sort === 'high'}" ng-click="$ctrl.setSort('high')">Highest price</button>
                <button class="filters__btn" ng-if="$ctrl.onSaleCount" ng-class="{active: $ctrl.filter === 'sale'}" ng-click="$ctrl.toggleSaleFilter()">On sale ({{ $ctrl.onSaleCount }})</button>
              </div>
            </div>
          </div>
        </div>
        <div class="catalog">
          <product-card ng-repeat="product in $ctrl.shown track by product._id" product="product" user="$ctrl.user"></product-card>
        </div>
        <div class="favorites__foot" ng-if="$ctrl.loading">
          <div class="loader loader--small"></div>
        </div>
      </div>
    </div>
    <div class="spage" ng-if="!$ctrl.grandTotal">
      <div class="spage__container">
        <div class="spage__preview">
          <img src="/img/no-purchases.avif" alt="Nothing saved yet">
        </div>
        <div class="spage__title">Nothing saved yet.</div>
        <div class="spage__content">Tap the heart on any product and it will be waiting for you here.</div>
        <a href="/category/featured-products" class="btn btn--submit">Explore products</a>
      </div>
    </div>`,

  controller: function ($scope, $window, $element, FavoriteService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.products = ctrl.data.products || [];
      ctrl.grandTotal = ctrl.data.total || 0;
      ctrl.total = ctrl.data.total || 0;
      ctrl.page = ctrl.data.page || 1;
      ctrl.categories = ctrl.data.categories || [];
      ctrl.category = null;
      ctrl.filter = "all";
      ctrl.sort = "recent";
      ctrl.loading = false;
      applyView();
      fillViewport();

      $window.addEventListener("scroll", onScroll, { passive: true });
      initTagScroll();
    };

    ctrl.$onDestroy = function () {
      $window.removeEventListener("scroll", onScroll);
      $($window).off("resize", ctrl._updateTagScroll);
    };

    ctrl.setCategory = function (slug) {
      if (ctrl.category === slug || ctrl.loading) return;
      ctrl.category = slug;
      ctrl.loading = true;

      FavoriteService.list(1, slug)
        .then(function (data) {
          ctrl.products = data.products;
          ctrl.total = data.total;
          ctrl.page = 1;
          applyView();
        })
        .finally(function () {
          ctrl.loading = false;
          fillViewport();
        });
    };

    ctrl.toggleSaleFilter = function () {
      ctrl.filter = ctrl.filter === "sale" ? "all" : "sale";
      applyView();
    };

    ctrl.setSort = function (sort) {
      ctrl.sort = sort;
      applyView();
    };

    ctrl.more = function () {
      if (ctrl.loading || ctrl.products.length >= ctrl.total) return;
      ctrl.loading = true;

      FavoriteService.list(ctrl.page + 1, ctrl.category)
        .then(function (data) {
          ctrl.page = data.page;
          ctrl.products = ctrl.products.concat(data.products);
          ctrl.total = data.total;
          applyView();
        })
        .finally(function () {
          ctrl.loading = false;
          fillViewport();
        });
    };

    // Infinite scroll: fetch the next page as the viewport nears the bottom
    function onScroll() {
      var doc = $window.document.documentElement;
      var remaining =
        doc.scrollHeight - $window.pageYOffset - $window.innerHeight;

      if (remaining < 600) {
        $scope.$applyAsync(function () {
          ctrl.more();
        });
      }
    }

    // Tall viewports can swallow the whole first page — no overflow means
    // no scroll events, so nothing would ever trigger more(). Re-check
    // after every load until the page overflows or results run out.
    function fillViewport() {
      setTimeout(function () {
        var doc = $window.document.documentElement;
        if (
          doc.scrollHeight <= $window.innerHeight + 200 &&
          ctrl.products.length < ctrl.total &&
          !ctrl.loading
        ) {
          $scope.$applyAsync(function () {
            ctrl.more();
          });
        }
      }, 150);
    }

    // Category strip scroll — same mechanism as the category pages
    // (tag-filter.js): arrow nav + is-prev/is-next feather masks
    function initTagScroll() {
      setTimeout(function () {
        var tags = $element.find(".filters__tags--favorites");
        if (!tags.length) return;

        var scroll = tags.find(".filters__scroll"),
          inner = scroll.find(".filters__inner"),
          nav = tags.find(".filters__nav");

        if (inner.width() > scroll.width()) {
          tags.addClass("is-next");
        }

        nav.on("click", function () {
          var _this = $(this),
            scrollOffset = scroll.width() / 2;

          if (_this.hasClass("filters__nav--prev")) {
            scroll.scrollLeft(scroll.scrollLeft() - scrollOffset);
          } else {
            scroll.scrollLeft(scroll.scrollLeft() + scrollOffset);
          }
        });

        function updateScroll() {
          var el = scroll[0];
          var scrollLeft = el.scrollLeft;
          var maxScrollLeft = el.scrollWidth - el.clientWidth;

          if (scrollLeft > 0) {
            tags.addClass("is-prev");
          } else {
            tags.removeClass("is-prev");
          }

          if (scrollLeft < maxScrollLeft - 1) {
            tags.addClass("is-next");
          } else {
            tags.removeClass("is-next");
          }
        }

        ctrl._updateTagScroll = updateScroll;
        scroll.on("scroll", updateScroll);
        $($window).on("resize", updateScroll);
        updateScroll();
      }, 10);
    }

    function isOnSale(p) {
      return p.on_sale || (p.seasonal_promo_enabled && p.site_promo);
    }

    function effectivePrice(p) {
      return p.seasonal_promo_enabled && p.site_promo
        ? p.seasonal_promo_price
        : p.price;
    }

    // Sale filter + sort operate on the loaded pages; the on-sale count
    // grows as more pages stream in
    function applyView() {
      ctrl.onSaleCount = ctrl.products.filter(isOnSale).length;

      var shown =
        ctrl.filter === "sale"
          ? ctrl.products.filter(isOnSale)
          : ctrl.products.slice();

      if (ctrl.sort === "low" || ctrl.sort === "high") {
        shown.sort(function (a, b) {
          var diff = (effectivePrice(a) || 0) - (effectivePrice(b) || 0);
          return ctrl.sort === "low" ? diff : -diff;
        });
      }

      ctrl.shown = shown;
    }
  },

  bindings: {
    data: "<",
    user: "<",
  },
});
